<script>
    import { notificate } from '../../../services/notification.js';
    import * as integrationService from "../service.js";
    import BreadCrumNav from "../../../components/breadcrum-nav.svelte";
    import API from '../../../services/api.svelte.js';
    import { onMount, tick } from 'svelte';
    import { format } from 'svelte-i18n';

    const env = VULSEEK_ENVIRONMENT;

    let Dockerfile = '';
    const YAML = integrationService.originalYAML;
    let tooltip = $state();
    let tooltipDocker = $state();
    let tooltipDockerCompose = $state();
    let postAddModal;
    let dockerModal;
    let dockerComposeModal;
    let responseCopied = false;
    let postAddResponse = $state();
    let config_selected = $state('');
    let yamlFile = $state();

    async function handleSubmit(download) {
        if(responseCopied) responseCopied = false;
        config_selected = download;
        let result = await notificate('confirm_scanner', "modal", {fileType: config_selected});

        if (!result.isConfirmed) {
            return false;
        }

        integrationService.save({name: "vulseek-scanner", role: "operator"}, [], {})
            .then(savedIntegration => {
                let data = savedIntegration;
                postAddResponse = data.secret;
                yamlFile = String.raw`x-common-configuration:
  &scanner_image public.ecr.aws/securetia/vulseek/scanner:${env}
services:
  ofelia:
    image: mcuadros/ofelia:0.3.17
    restart: unless-stopped
    command: daemon --docker
    volumes:
      - /var/run/docker.sock:/var/run/docker.sock:ro
    labels:
      # Job to delete scan results older than 30 days
      ofelia.job-run.purge-old-scan-reports.schedule: "@daily"
      ofelia.job-run.purge-old-scan-reports.image: "alpine:latest"
      ofelia.job-run.purge-old-scan-reports.command: "sh -c 'find /tmp -type d -depth -mtime +30 -exec rm -rf {} + && find /tmp -type f -mtime +30 -delete'"
      ofelia.job-run.purge-old-scan-reports.volume: "[\"/var/tmp/vulseek-scanner:/tmp\"]"
      # Job to delete untagged or unreferenced Docker images (useful to claim space occupied by older versions of the scanner)
      ofelia.job-run.purge-dangling-images.schedule: "@weekly"
      ofelia.job-run.purge-dangling-images.image: docker:cli
      ofelia.job-run.purge-dangling-images.pull: "true"
      ofelia.job-run.purge-dangling-images.command: "docker image prune -f"
      ofelia.job-run.purge-dangling-images.volume: "[\"/var/run/docker.sock:/var/run/docker.sock:ro\"]"
      # Scheduling format can be configured based on the Go implementation of cron (https://pkg.go.dev/github.com/robfig/cron)
      ofelia.job-run.default-scan.schedule: "@every 6h" # Scans are executed once every 6 hours and for all assets by default
      ofelia.job-run.default-scan.image: *scanner_image
      ofelia.job-run.default-scan.pull: "true" # Always scan with the most up to date version of the scanner so far
      ofelia.job-run.default-scan.no-overlap: "true" # Do not start a new scan if previous hasn't finished
      ofelia.job-run.default-scan.volume: "[\"/var/tmp/vulseek-scanner:/tmp\"]" # Store scan results in /var/tmp/vulseek-scanner
      ofelia.job-run.default-scan.environment: "[\"API_URL=${API.url}\",\"API_KEY=${postAddResponse}\"]"
      # For further customization different jobs can be created with Ofelia (https://github.com/mcuadros/ofelia)
      # For example to scan the assets tagged as "critical" every night at 1 AM the following configuration can be used:
      # ofelia.job-run.critical-scan.schedule: "0 0 1 * * *" (Note: the format starts with seconds, instead of minutes.)
      # ofelia.job-run.critical-scan.image: *scanner_image
      # ofelia.job-run.critical-scan.pull: "true"
      # ofelia.job-run.critical-scan.no-overlap: "true"
      # ofelia.job-run.critical-scan.environment: "[\"ONLY_TAGGED_AS=critical\",\"API_URL=${API.url}\",\"API_KEY=${postAddResponse}\"]"
`;
/*                Dockerfile = `docker run -d \\
--name vulseek-scanner \\
--restart=unless-stopped \\
-e PYTHONUNBUFFERED=1 \\
-e API_URL=${API.url} \\
-e API_KEY=${postAddResponse} \\
public.ecr.aws/securetia/vulseek/scanner:latest`;*/
                postAddModal.modal('show');
                return true;
            })
            .catch(errors => {
                return false;
            })
        ;
        return true;
    }

    const closeResponseModal = async () =>{
        if(!responseCopied) {
            let result = await notificate('confirm_secret_closure', "modal", {fileType: config_selected});
            if (!result.isConfirmed) {
                return false;
            }
        }
        responseCopied = true;
        postAddModal.modal('hide');
    }

    const handleCopy = async (str, tooltip) => {
        copyText(str, tooltip);
    }

    const copyText = async (str, tooltip) => {
        await tick();
        if ('clipboard' in navigator) {
            navigator.clipboard.writeText(str)
            .then(() => {
                showTooltip(tooltip);
                hideTooltip(tooltip);
            })
            .catch((err) => console.error(err.name, err.message));
        }
        else {
            let selBox = document.createElement('textarea');
            selBox.style.position = 'fixed';
            selBox.style.left = '0';
            selBox.style.top = '0';
            selBox.style.opacity = '0';
            selBox.value = str;
            document.body.appendChild(selBox);
            selBox.focus();
            selBox.select();
            // @TODO: upgrade to clipboard API
            try{
                const success = document.execCommand('copy');
            }
            catch(err){
                return false;
            }
            showTooltip(tooltip);
            document.body.removeChild(selBox);
            hideTooltip(tooltip);
            responseCopied = true;
        }
        responseCopied = true;
    }

    const hideTooltip = (tooltip) =>{
        setTimeout(()=>{
            tooltip.classList.add('trigger-opacity-cero');
            tooltip.classList.remove('trigger-opacity-one');
            setTimeout(()=>tooltip.classList.add('d-none'), 1000);
        }, 2000);
    }

    const showTooltip = (tooltip) => {
        tooltip.classList.remove('d-none');
        setTimeout(()=>{
            tooltip.classList.remove('trigger-opacity-cero');
            tooltip.classList.add('trigger-opacity-one');
        }, 1000);
    }


    const downloadFile = async (file = "docker") => {
        if(file == "docker"){
            return;
        }
        else if(file == "compose"){
            const fileBlob = new Blob([yamlFile], {type: "application/yaml"});
            const fileUrl = URL.createObjectURL(fileBlob);
            const anchor = document.createElement("a");
            anchor.href = fileUrl;
            anchor.download = "vulseek-scanner.yaml";
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);

            URL.revokeObjectURL(fileUrl);
        }
        else {
            return;
        }
        responseCopied = true;
    }

    onMount(()=>{
        postAddModal = jQuery('#postAdd-modal').modal({show: false});
        dockerModal = jQuery('#docker-modal').modal({show: false});
        dockerComposeModal = jQuery('#dockercompose').modal({show: false});
    });

</script>
<style>
    .icon i {
        width: 100px;
        top: -20px !important;
    }
    .icon i img {
        max-width: 100%;
    }

    .console{
        background: hsl(0,0%,96.5%);
        color: black-750;
        font-family: "Lucida Console", "Courier New", monospace;
        white-space: break-spaces;
        padding: 15px;
    }
    .btn-copy {
        float: right;
        position: relative;
        top: 5px;
        right: 5px;
    }
    .icon i.docker-img-container {
        width: 120px !important;
        right: 25px !important;
    }
    #tooltip-dockerfile {
        position: absolute;
        right: -60px;
        top: 145px;
    }
    #tooltip-response {
        position: absolute;
        right: -60px;
        top: 77px;
    }
    #tooltip-compose {
        position: absolute;
        right: -60px;
        top: 50px;
    }
</style>


<section class="content-header">
    <div class="container-fluid">
        <div class="row">
            <div class="col-6">
                <h1 class="mt-3 mb-3 page-title">
                    <i class="fas fa-crosshairs fa-xs"></i>
                    Vulseek Scanner
                </h1>
            </div>
            <div class="col-6">
                <BreadCrumNav routes={[{path: "/integration/", label: $format("layout.sidebar.integrations")},{ label: "Vulseek Scanner" }]} />
            </div>
       </div>
    </div>
</section>

<section class="content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        {@html $format("page.integration.scanner.text")}
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-6 d-flex" style="gap: 15px;">
                <!--<div class="small-box bg-white" style="flex: 1;" type="button" id="dockerfileBtn"  on:click={()=>handleSubmit('docker')}>
                    <div class="inner">
                        <h3>Docker</h3>
                        <p>Obtener configuración</p>
                        <div class="icon">
                            <i class="docker-img-container"><img src="/img/logo-docker.png" alt="" /></i>
                        </div>
                    </div>
                </div>-->
                <div aria-label="Descargar configuración para docker compose" type="button" id="dockercomposeBtn" onclick={()=>handleSubmit('compose')} class="small-box bg-white" style="flex: 1;">
                    <div class="inner">
                        <h3>Docker Compose</h3>
                        <p>{$format("page.integration.scanner.compose")}</p>
                        <div class="icon">
                            <i><img src="/img/logo-docker-compose.png" alt="" /></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- POSTADD MODAL -->
<div class="modal fade show" id="postAdd-modal" data-keyboard="false" data-backdrop="static" style="display: none; padding-right: 9px;" aria-modal="true" role="dialog">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">{$format("page.integration.scanner.modal.title")}</h4>
              <button type="button" class="btn-close" onclick={closeResponseModal} aria-label="Close">
              </button>
            </div>
            <div class="modal-body">
                {#if config_selected == 'docker'}
                    <div>La clave generada ya está lista para usar. Podés copiarla al portapapeles o directamente copiar el comando necesario para desplegar la imagen utilizando Docker.</div>
                    <button class="btn btn-copy far fa-copy" title="Copiar al portapapeles" aria-label="Copiar" onclick={()=>handleCopy(postAddResponse, tooltip)}></button>
                    <span id="tooltip-response" class="d-none trigger-opacity-cero copy-tooltip" bind:this={tooltip}>Copiado</span>
                    <div class="console mb-3">
                        {postAddResponse}
                    </div>
                    <button class="btn btn-copy far fa-copy" title="Copiar al portapapeles" aria-label="Copiar" onclick={()=>handleCopy(Dockerfile, tooltipDocker)}></button>
                    <span id="tooltip-dockerfile" class="d-none trigger-opacity-cero copy-tooltip copy-tooltip-docker" bind:this={tooltipDocker}>Copiado</span>
                    <div class="console">
                        {Dockerfile}
                    </div>
                {:else}
                    <div class="mb-3">{$format("page.integration.scanner.modal.download_ready")}</div>
                    <button class="btn btn-copy far fa-copy" title="Copiar al portapapeles" aria-label="Copiar" onclick={()=>handleCopy(yamlFile, tooltipDockerCompose)}></button>
                    <span id="tooltip-compose" class="d-none trigger-opacity-cero copy-tooltip" bind:this={tooltipDockerCompose}>{$format("copied")}</span>
                    <div class="console mb-3">
                        {yamlFile}
                    </div>
                    <div class="mt-3 mb-3">
                        <button class="btn btn-default" onclick={()=>downloadFile(config_selected)}>{$format("buttons.download_file")}</button>
                    </div>
                {/if}

            </div>
        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>
<!-- END POSTADD MODAL-->